import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import toast from "react-hot-toast";

// constants
import LocalStrings from "@language";
import { validateEmail } from "@utilscommon";

// actions
import { reviewerLoginAction } from "@revieweractions";

// components
import { renderFieldText, renderSpinner } from "@basecomponent";

const CREDS_INIT = {
  email: "",
  password: "",
};

const ReviewerLogin = (props) => {
  const { session, eventData } = props;

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [creds, setCreds] = useState(CREDS_INIT);
  const [validation, setValidation] = useState(CREDS_INIT);

  const handleLogin = () => {
    if (loading) return;

    if (
      _.isEmpty(creds?.email) ||
      (!_.isEmpty(creds?.email) && !validateEmail(creds?.email))
    ) {
      setValidation({ ...validation, email: LocalStrings.kInvalidEmail });
      return;
    }
    if (_.isEmpty(creds?.password)) {
      setValidation({ ...validation, password: LocalStrings.kInvalidPasscode });
      return;
    }

    setLoading(true);
    props.reviewerLoginAction(session, creds, { eventData }, (res) => {
      setLoading(false);
      if (res.success && res?.data?.isLoggedIn) navigate("/reviewer");
    });
  };

  const handleFieldOnChange = (name, value) => {
    setValidation((prevState) => ({
      ...prevState,
      [name]: "",
    }));

    setCreds((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <section className="h-full w-full bg-offwhite flex justify-center items-center">
      {/* ----- Login component ----- */}
      <div className="flex flex-col items-center gap-8">
        {/* --- Header --- */}
        <label className="text-xl font-semibold text-gray-900">
          {LocalStrings.static.kReviewerLogin}
        </label>

        {/* --- Body --- */}
        <section className="h-80 w-80 bg-white rounded shadow-md flex flex-col gap-6 p-4">
          {/* - Secondary label - */}
          <div className="w-full flex justify-center align-center">
            {LocalStrings.static.kSignInToStart}
          </div>

          {/* - Email - */}
          <div className="w-full">
            {renderFieldText({
              input: {
                name: "email",
                onChange: (e) => handleFieldOnChange("email", e.target.value),
              },
              type: "email",
              label: LocalStrings.kEmail,
              placeholder: LocalStrings.kEnterEmailAddress,
              mandatory: "true",
              meta: {
                touched: !_.isEmpty(validation?.email),
                error: validation?.email,
              },
            })}
          </div>

          {/* - Password - */}
          <div className="w-full">
            {renderFieldText({
              input: {
                name: "password",
                onChange: (e) =>
                  handleFieldOnChange("password", e.target.value),
              },
              type: "password",
              label: LocalStrings.kLabelPasscode,
              placeholder: LocalStrings.kEnterPasscodeText,
              mandatory: "true",
              meta: {
                touched: !_.isEmpty(validation?.password),
                error: validation?.password,
              },
            })}
          </div>

          {/* - Submit button - */}
          <div className="w-full flex justify-center items-center">
            <button
              type="button"
              className="bg-themeLight active:bg-theme rounded text-white px-3 py-2 flex justify-center items-center"
              disabled={loading}
              onClick={handleLogin}
            >
              {loading && renderSpinner(true)}
              <span>{LocalStrings.kLoginPortalText}</span>
            </button>
          </div>
        </section>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.sessionReviewer,
    eventData: state.eventData,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ reviewerLoginAction }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReviewerLogin);
